import { render, staticRenderFns } from "./ViewUpdateCustomer.vue?vue&type=template&id=0c056ad7&scoped=true"
import script from "./ViewUpdateCustomer.vue?vue&type=script&lang=js"
export * from "./ViewUpdateCustomer.vue?vue&type=script&lang=js"
import style0 from "./ViewUpdateCustomer.vue?vue&type=style&index=0&id=0c056ad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c056ad7",
  null
  
)

export default component.exports